// extracted by mini-css-extract-plugin
export default {"container":"SettingsButton_container__bhMOA","flex":"SettingsButton_flex__oOPY+","secondFlexItem":"SettingsButton_secondFlexItem__3MEcG"};